import React, {ReactNode} from 'react';
import I18n from 'app/i18n';
import {goToMarketplaceWithName} from 'app/utils/app_links';
import {PokerStore} from 'app/store/PokerStore';
import {inject, observer} from 'mobx-react';
import scrollImage from 'images/poker/poker-scroll.png';
import {isDesktop, scrollToTop} from 'app/utils';

interface Props {
    pokerStore?: PokerStore
    table_id: string
}

@inject('pokerStore')
@observer
export default class PokerPopupBuyScroll extends React.Component<Props> {
    handleGoToShop = (): void => {
        goToMarketplaceWithName('cbt-scroll');
        this.props.pokerStore.getTable(this.props.table_id).closeTable();
        scrollToTop();

        if (!isDesktop()) {
            document.body.classList.remove('body-overflow');
        }
    };

    render(): ReactNode {
        return <div className="poker-main-artifact">
            <div className="poker-main-artifact-content">
                <p dangerouslySetInnerHTML={{__html: I18n.t('poker.purchase_scroll')}}></p>
                <div className="poker-main-artifact-container">
                    <img
                        className="poker-main-artifact-image"
                        src={scrollImage}
                        alt="scroll image"
                    />
                    <button className="button-adaptive button-poker-main-artifact" onClick={this.handleGoToShop}>
                        {I18n.t('poker.to_shop')}
                    </button>
                </div>
            </div>
        </div>;
    }
}
